export const hideProfileItems = (user) => {
    if (
        user?.OrganizationId === "6478935c63e4e900122e2052" //adny summer
        || user?.OrganizationId === "64a977a2c833bb00119b913f" //Everitt Bridge
    ) {
        return false
    }
    return true
}